export enum TourSubTypes {
  HEALTH_TOURISM = 'HealthTourism',
  CYPRUS_TOUR = 'CyprusTour',
}
